<template>
  <div :class="dropDownClass" ref="dropDownRef">
    <div
      class="input"
      id="search-box"
      @click="handleOpen"
      :style="searchBoxStyles"
    >
      <span>{{ serverInfo.serverName }}</span>
      <MBIcon
        name="icon-black-arrow"
        :size="iconSize"
        :color="iconColor"
        :opacity="0.5"
      />
    </div>
    <div class="down-list" v-show="isDown" :style="downListStyles">
      <div class="down-tips" ref="downTips" @click="handlerclick">
        <span
          class="title"
          :style="{ color: serverItemFontColor, opacity: 0.5 }"
          >{{ $t('publicDetails.PleaseServerDesc') }}</span
        >
        <MBIcon
          name="icon-black-arrow"
          :size="iconSize"
          @click="handlerclick"
          :color="iconColor"
          :opacity="0.5"
        />
      </div>
      <div class="search" ref="searchContent">
        <input
          ref="searchRef"
          class="search-input"
          type="text"
          @input="fuzzySearch"
          v-model="searchName"
          :style="downListSearchStyles"
        />
      </div>

      <div class="server-list" ref="serListRef">
        <div
          v-for="(item, index) in copyServerList"
          :key="item.cpServerId + index"
          :id="`item-${item.cpServerId}`"
          :class="['item', item.active ? 'active' : '']"
          :style="{
            color: serverItemFontColor,
          }"
          @click="handleSelected(item)"
        >
          {{ item.serverName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import throttle from 'lodash/throttle'
  import cloneDeep from 'lodash/cloneDeep'
  import isEmpty from 'lodash/isEmpty'
  import MBIcon from '@/components/MBIcon'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { createUidParames } from '@page_detail/utils/common'
  import { injectionCheckUid } from '@page_detail/utils/validators'
  import { storage } from '@/utils/storage'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  export default {
    mixins: [styleConfiguration],
    components: {
      MBIcon,
    },
    data() {
      return {
        isDown: false,
        searchName: '',
        copyServerList: [],
        serverInfo: {
          cpServerId: '',
          serverName: '',
        },
      }
    },
    computed: {
      ...mapState(['gameName', 'region', 'isMobile', 'isDesktop']),
      ...mapState('detail', [
        'serverList',
        'isTipsOpen',
        'serverUserId',
        'selectServerItem',
      ]),
      ...mapGetters([
        'selectedServiceKey',
        'displayModeClassName',
        'isParallelRequestsGame',
      ]),

      searchBoxStyles() {
        return {
          background: this.skuBackColor.backgroundColor,
          borderColor: this.skuBackColor.borderColor,
          color: this.mFontColor.color,
        }
      },

      iconColor() {
        return this.mFontColor.color
      },

      serverItemFontColor() {
        return this.mFontColor.color
      },

      downListStyles() {
        return this.skuBackColor
      },

      downListSearchStyles() {
        return {
          borderColor: this.skuBackColor.borderColor,
          color: this.mFontColor.color,
        }
      },
      iconSize() {
        if (this.isDesktop) return 22
        if (this.isMobile) return 40
        return 40
      },
      serverNameMsg() {
        return this.$t(`publicDetails.PleaseServerDesc`) || 'Select Server'
      },
      dropDownClass() {
        let defaultClass = [
          'drop-down-search-content',
          this.displayModeClassName,
          this.gameName,
        ]
        if (this.isParallelRequestsGame) {
          defaultClass = defaultClass.concat('parallel-games')
        }
        return defaultClass
      },
    },
    watch: {
      serverList: {
        handler(val) {
          if (val && val.length) {
            this.copyServerList = cloneDeep(val)
            this.defaultSelectd()
          } else {
            this.serverInfo = {
              cpServerId: '',
              serverName: this.serverNameMsg,
            }
          }
        },
        deep: true,
        immediate: true,
      },
      selectServerItem: {
        handler(newVal) {
          if (!isEmpty(newVal)) {
            this.checkUserUid(newVal)
          }
        },
        deep: true,
        immediate: true,
      },
      isTipsOpen(newVal) {
        if (newVal) {
          this.isDown = false
        }
      },
    },
    created() {
      this.init()
    },
    mounted() {},
    destroyed() {
      this.handlerDocumentClick(false)
    },
    methods: {
      ...mapMutations(['detail/setCheckServerItem', 'detail/setNickName']),
      init() {
        if (process.server) return
        this.defaultServerText()
        this.fuzzySearch = throttle(this.fuzzySearch, 300)
        this.handlerDocumentClick()
      },

      // 校验UID
      async checkUserUid(selectServerItem = {}) {
        try {
          let params = {}
          const cacheId = storage.get(this.selectedServiceKey)
          if (!this.serverUserId?.value) return

          if (cacheId) {
            params = {
              gameName: this.gameName,
              uid: this.serverUserId.value,
              cpServerId: cacheId,
            }
          } else {
            params = createUidParames({
              gameName: this.gameName,
              uid: this.serverUserId.value,
              selectServerItem,
            })
          }

          const result = await injectionCheckUid(params)
          if (result && result.res) {
            let nickNameList = result.nick || result.roles || ''
            this['detail/setNickName'](nickNameList || '')
            this.setStorageServerId(params.cpServerId)
          } else {
            this['detail/setNickName']('')
          }
        } catch (error) {
          this['detail/setNickName']('')
          window.console.warn(
            '%c[__checkUserUid___]方法报错',
            'color:#0f0',
            error
          )
        }
      },
      defaultServerText() {
        const { cpServerId, serverName } = this.serverInfo
        if (cpServerId === '' && serverName === '') {
          this.serverInfo.serverName = this.serverNameMsg
        }
      },

      // 点击空白处关闭
      handlerDocumentClick(isBind = true) {
        if (isBind) {
          document.addEventListener('click', this.hidePanel, false)
          return
        }
        document.removeEventListener('click', this.hidePanel, false)
      },

      hidePanel(e) {
        if (!this.$refs.dropDownRef.contains(e.target)) {
          this.isDown = false
        }
      },

      // 默认选中
      defaultSelectd() {
        let cpServerId = storage.get(this.selectedServiceKey) || null
        // warn: 缓存没有的话、默认选中第一个
        if (!cpServerId) {
          cpServerId = this.serverList[0].cpServerId
        }

        let result = this.serverList.find(
          (item) => item.cpServerId === cpServerId
        )

        if (!result) {
          result = this.serverList[0]
        }

        this.serverInfo = result || this.serverInfo || {}
        this['detail/setCheckServerItem'](this.serverInfo)
      },
      // 打开、聚焦
      handleOpen() {
        this.isDown = !this.isDown
        this.searchName = ''

        this.$nextTick(() => {
          this.$refs.searchRef && this.$refs.searchRef.focus()
          this.scrollVisualArea()
          this.recordSelected()
          this.renderDownTips()
        })
      },

      // 回显输入框的状态
      renderDownTips() {
        const { cpServerId, serverName } = this.serverInfo
        this.searchName = cpServerId ? serverName : ''
      },

      // 记录缓存选中的状态
      recordSelected() {
        const { cpServerId } = this.getServerInfo()
        this.copyServerList = this.serverList

        this.copyServerList = this.copyServerList.map((item) => {
          item.active = item.cpServerId === cpServerId
          return item
        })
      },
      // 模糊搜索
      fuzzySearch() {
        const _searchName = this.searchName.toLowerCase()
        const list = this.serverList.filter(
          (item) => item.serverName.toLowerCase().indexOf(_searchName) !== -1
        )
        this.copyServerList = list
      },

      // 选中状态
      handleSelected(item) {
        this.serverInfo = item
        this.isDown = false

        this['detail/setCheckServerItem'](item)
      },

      // 更新缓存
      setStorageServerId(data) {
        storage.set(this.selectedServiceKey, data)
      },

      // 获取server详细信息
      getServerInfo() {
        const cpServerId = storage.get(this.selectedServiceKey)
        if (this.serverInfo) return this.serverInfo

        if (!cpServerId) return {}

        return this.serverList.find((item) => item.cpServerId === cpServerId)
      },

      // 滚动到可视区
      scrollVisualArea() {
        const { cpServerId = '' } = this.getServerInfo()
        if (!cpServerId) return

        this.$nextTick(() => {
          const el = document.querySelector(`#item-${cpServerId}`)
          if (!el) return

          const elTop = el.offsetTop
          const result = this.getSumFocusingDOM()

          if (this.$refs.serListRef) {
            this.$refs.serListRef['scrollTop'] = elTop - result
          }
        })
      },

      // 获取聚焦dom的高度
      getSumFocusingDOM() {
        const tipsRef = this.$refs.downTips
        const seaRef = this.$refs.searchContent

        const searchContent = seaRef ? seaRef['offsetHeight'] : 0
        const downTips = tipsRef ? tipsRef['offsetHeight'] : 0

        return searchContent + downTips
      },

      handlerclick() {
        this.isDown = false
      },
    },
  }
</script>

<style lang="scss" src="./styles.scss" scoped></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
